// src/pages/RegisterPage.js
import React from "react";
import RegisterForm from "../components/RegisterForm";
import styles from "../css/Login.module.css"; // ✅ Apunta al CSS de Login

const RegisterPage = () => {
  return (
    // Usa el contenedor principal del CSS de Login
    <div className={styles.pageContainer}>
      <RegisterForm />
    </div>
  );
};

export default RegisterPage;
